import { Col, Row, Text } from 'components';
import { theme } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { DonutChart } from './';

const Total = ({ total, data }) => {
  const [selected, setSelected] = useState({ type: 'all', label: 'All' }),
    totalNum = selected?.roundedTotal || total || 0,
    totalPercentage = ((totalNum * 100) / total).toFixed(0),
    { t } = useTranslation(),
    user = useSelector((state) => state.user);

  return (
    <Col start>
      <Text h2>{t('dashboard.total')}</Text>

      <Col marg="8px 0 0" ht="634px" bg="#fff" wid="100%" noFlex start centerAll>
        <Text h0 center marg="48px 0 0">
          {total?.toLocaleString(undefined, {
            style: 'currency',
            currency: user.billing?.currency || 'usd'
          })}
        </Text>

        <Text marg="48px 0 0" b1 med center>
          {selected?.label}
        </Text>

        <Row marg="4px 0 0" evenly>
          <Row end>
            <Text h3>
              {totalNum.toLocaleString(undefined, {
                style: 'currency',
                currency: user.billing?.currency || 'usd'
              })}{' '}
              /
            </Text>
            <Text b1 col={theme.GREY_60} marg="0 0 0 4px">
              {isNaN(totalPercentage) ? 0 : totalPercentage}%
            </Text>
          </Row>
        </Row>

        <Col center noFlex marg="18px 0 0">
          <DonutChart data={data} setSelected={setSelected} selected={selected} />
        </Col>
      </Col>
    </Col>
  );
};

export default Total;
